module.exports = require("swa-bootstrap-corporate-landing-home-page/login-settings.corporate");